import {useEffect, useState} from "react";
import {ICountry} from "../utils/countryList/ICountry"
import {useI18nState} from "./index";

export default function useCountries() {
  const { getCountriesByCurrentLangCode, selectedLanguage } = useI18nState();
  const [countries, setCountries] = useState<ICountry[]>([]);
  
  useEffect(() => {
    getCountriesByCurrentLangCode().then((countries:ICountry[]) =>
      setCountries(countries)
    );
  }, [getCountriesByCurrentLangCode, selectedLanguage]);

  return countries;
}
